// extracted by mini-css-extract-plugin
export default {"formContainer":"TranslateEventCategoryForm_formContainer__Pc-kU"};